import React from 'react';
import Icon, { Props } from './icon';

export const RecordingStorageSymbol: React.FC<Props> = (props: Props) => {
  return (
    <Icon viewBox="0 0 64 64" {...props}>
      <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="30" stroke="currentColor" strokeOpacity="0.2" strokeWidth="4" />
        <circle cx="32" cy="32" r="20" fill="currentColor" />
      </svg>
    </Icon>
  );
};

export default React.memo(RecordingStorageSymbol);
